import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/analytics-api.service';
import type { AnalyticsQueryParams } from '../types/analytics.types';

export const fpTrendingCategoriesKeys = {
  all: ['analytics', 'fp-trending-categories'] as const,
  list: (params?: AnalyticsQueryParams) =>
    [...fpTrendingCategoriesKeys.all, 'list', params] as const,
};

export const useFPTrendingCategoriesData = (params?: AnalyticsQueryParams, enabled = true) => {
  return useQuery({
    queryKey: fpTrendingCategoriesKeys.list(params),
    queryFn: async () => {
      const response = await analyticsApi.getFPTrendingCategories(params);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    enabled,
  });
};
